import Box from 'ui/src/components/Box'
import IconButton from 'ui/src/components/IconButton'
import NotificationsMenu from 'pages/common/Notifications/components/Menu'
import { NotificationsIcon } from 'ui/src/assets/icons'
import { Tooltip } from 'ui/src/components/Tooltip'

interface NotificationsProps {
  isNotificationsOpen: boolean
  setIsNotificationsOpen: (value: boolean) => void
  allNotifications: any
  setRefetchData: (value: boolean) => void
  hasUnreadNotifications: boolean
}

const Notifications = ({
  isNotificationsOpen,
  setIsNotificationsOpen,
  allNotifications,
  setRefetchData,
  hasUnreadNotifications,
}: NotificationsProps) => {
  const handleNotificationsClick = () => {
    setIsNotificationsOpen(!isNotificationsOpen)
  }

  const bellIconColor = isNotificationsOpen ? '#4C89D3' : '#0056C0'

  return (
    <>
      <Box
        sx={{
          position: 'relative',
        }}
      >
        <Tooltip title="Notifications">
          <IconButton
            sx={{ width: '100%', height: '100%', cursor: 'pointer' }}
            className="bell"
            onClick={handleNotificationsClick}
          >
            <NotificationsIcon sx={{ color: bellIconColor, width: '1.25rem', height: '1.25rem' }} />
            {hasUnreadNotifications && (
              <div
                style={{
                  width: 10,
                  height: 10,
                  borderRadius: '50%',
                  background: '#BE0027',
                  border: '0.063rem solid #FFFFFF',
                  position: 'absolute',
                  right: 8,
                  top: 8,
                }}
              />
            )}
          </IconButton>
        </Tooltip>
        <NotificationsMenu
          isOpen={isNotificationsOpen}
          allNotifications={allNotifications}
          setRefetchData={setRefetchData}
          setIsOpen={setIsNotificationsOpen}
        />
      </Box>
    </>
  )
}

export default Notifications
